// extracted by mini-css-extract-plugin
module.exports = {"contentBankListCards":"style_contentBankListCards__pYoVQ","loading":"style_loading__w6P18","containerBankList":"style_containerBankList__E3sk9"};